import { restApi } from '../../../services/api';

const PATH = '/invites';

export const myNetworkInvitesSuggestionRepository = () => {
  const getInvitesSuggestions = () => restApi.get(`${PATH}?type=SUGGESTIONS`);
  const reject = (id: string): any => restApi.patch(`${PATH}/${id}/reject`);
  const connect = (id: string): any => restApi.patch(`${PATH}/${id}/connect`);
  const remove = (id: string): any => restApi.delete(`${PATH}/${id}`);
  const updateMessage = (id: string, message: string) =>
    restApi.patch(`${PATH}/${id}`, { message });

  return {
    getInvitesSuggestions,
    reject,
    connect,
    remove,
    updateMessage,
  };
};
